import ReactGA from 'react-ga4';
import { gaToken } from '../../constants/Config';
import { COOKIEPREF_COOKIE_AGE } from '../../constants/AppConstants';

const setAnalyticCookie = (cookiePreference) => {
  if (cookiePreference === true) {
    document.cookie = `cookiePreference=true; max-age=${COOKIEPREF_COOKIE_AGE};`;
    window[`ga-disable-${gaToken}`] = false;
    ReactGA.send('pageview');
  } else if (cookiePreference === false) {
    document.cookie = `cookiePreference=false; max-age=${COOKIEPREF_COOKIE_AGE};`;
    window[`ga-disable-${gaToken}`] = true;
  } else {
    window[`ga-disable-${gaToken}`] = true;
  }
};

export default setAnalyticCookie;
